<template>
  <div class="ui-table">
    <!-- 列表区 -->
    <a-table
        ref="elTable"
        :height="tableFixedHeight"
        :loading="loading || dicLoading"
        :columns="innerFileds" :data-source="tableData"
        style="width: 100%">

        <!-- 其它显示列 -->
        <template v-for="(item,i) in innerFileds" :slot="item.key" slot-scope="slotItem">
          <div :key="i">
              <!-- 正常展示 -->
              <div class="in-block" v-if="!item.slot" :class="{'no-wrap' : item.noWrap, 'no-break' : item.noBreak}">
                <!-- 判空 -->
                <span v-if="!slotItem[item.key] && slotItem[item.key] !== 0 && slotItem[item.key] !== '0'">--</span>
                <!-- 字典 -->
                <span v-else-if="item.type == 'dictionary'" :title="slotItem[item.key] | DictionaryFilter(item.dicKey, coInsNo)">
                  {{slotItem[item.key] | DictionaryFilter(item.dicKey, coInsNo)}}
                </span>
                <!-- 原始文本 -->
                <span v-else :title="slotItem[item.key]">
                  {{slotItem[item.key]}}
                </span>
              </div>
              <!-- 插槽 -->
              <slot v-if="item.slot" :name="item.key" :item="slotItem"></slot>
            </div>
        </template> 
    </a-table>

    <!-- 操作区 -->
    <div class="operation-area clearfix" v-if="!hideOperate">
      <!-- 左侧按钮 -->
      <!-- <div class="left-btn fl" v-if="tableExtra.check">
        <div class="default-btn mar-r-10px" @click="checkAll()">选择全部</div>
        <div class="default-btn" @click="reverseCheck()">反向选择</div>
      </div> -->
      <!-- 分页 -->
      <div class="right-page fr" v-if="pageParams.pageNum">
        <a-pagination
          layout="prev, pager, next"
          @current-change="pageChange"
          :current-page="pageParams.pageNum"
          :page-size="pageParams.pageSize"
          :total="pageParams.totalRows ? Number(pageParams.totalRows) : 0">
        </a-pagination>
      </div>
      <span class="primary-btn-color total-count fr" v-if="pageParams.totalRows">筛选结果(<span class="red">{{pageParams.totalRows}}</span>)</span>
    </div>
  </div>
</template>

<script>
import '@common/filters/dictionary.filter.js';
export default {
    name : 'UiTable',
    props : {
      tableFields : {
        type : Array,
        default : () => [],
      },
      // 额外配置
      tableExtra : {
        type : Object,
        default : () => {return {}},
      },
      // 合并项
      mergeKeyList : {
        type : Array,
        default : () => []
      },
      // 分页
      pageParams : {
        type : Object,
        value : {},
        default : () => {return {}},
      },
      // 是否有边框
      hasBoder : {
        type : Boolean,
        default : false,
      },
      // 加载中
      loading : {
        type : Boolean,
        default : false,
      },
      // 隐藏操作区
      hideOperate : {
        type : Boolean,
        default : false,
      },
      // 表格高度
      tableFixedHeight : {
        type : String|Number,
        default : 'auto',
      },
      // 表格行指定key
      tableRowKey : {
        type : String,
        default : 'id'
      },
      // 表格对齐方式
      align : {
        type : String,
        default : 'center'
      }
    },
    data () {
        return {
          coInsNo    : '',      // 当前查询的合作机构号
          innerFileds : [],
          tableData  : [],
          selections : [],
          dicLoading : false,   // 加载数据字典中
        }
    },
    watch : {
      tableFields : {
        immediate : true,
        handler (newVal=[], oldVal) {
          this.innerFileds = newVal.map(item => {
            item.scopedSlots = {customRender : item.key}
            return item;
          })
        }
      }
    },
    methods : {
      
      // @public()
      // 设置数据
      setData (tarData) {
        this.tableData = JSON.parse(JSON.stringify(tarData));
      },
      // 设置行的类名
      setRowClass (rowObj) {
        let className = 'ui-table-row ';
        // 判断是选中，选中给定样式类名
        this.selections.find(item => item.id == rowObj.row.id) ? className += 'selected ' : '';
        if (this.tableExtra.classNameFn) className += this.tableExtra.classNameFn(rowObj);
        return className;
      },
      // 全选
      checkAll () {
        this.$refs.elTable.toggleAllSelection();
      },
      // 反向选择
      reverseCheck () {
        this.tableData.map(item => {
          let key = this.tableExtra.check;
          if (this.selections.filter(sitem => sitem[key] == item[key]).length > 0) this.$refs.elTable.toggleRowSelection(item,false);
          else this.$refs.elTable.toggleRowSelection(item,true);
        })
      },
      // 排序事件改变 - ascending、descending、null
      sortChange (sortVal) {
        this.$emit('sortChange',sortVal);
      },
      // 页码改变
      pageChange (pageNum) {
        this.$emit('pageNumChange',pageNum);
      },
      // @public()
      // 获取当前选择项
      getSelection () {
        return this.selections.map(item => item[this.tableExtra.check]);
      },
      // 行点击，行单击
      trClick (row, col, cell, event) {
        this.$emit('trClick',row)
      },
      
      // 获取数据字典
      refreshDic (coInsNo) {
        this.coInsNo = coInsNo;
      },

      // 表格合并
      spanMergeFn ({row, column, rowIndex, columnIndex}) {
        if (!this.mergeKeyList || this.mergeKeyList.length === 0) return ;
        let rowspan = row.rowSpan ? row.rowSpan : 0,colspan = row.colSpan ? row.colSpan : 0;
        if ( this.mergeKeyList.indexOf(column.property) !== -1 ) {
          if ( rowspan || colspan ) return { rowspan : rowspan ? rowspan : 1, colspan : colspan ? colspan : 1 };
          else return [0,0]
        }
      }
    }
}
</script>

<style lang="less" scoped>
// 注：部分样式在public/css中覆盖，不在此处复写
.operation-area{
  padding:10px 0;
  // 筛选结果
  .total-count{
    height:35px;
    line-height:35px;
    font-size:14px;
  }
}
// 不允许换行
.no-wrap{
  white-space: nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
}
// 单纯不换行
.no-break{
  white-space: nowrap;
}

// 分页
.right-page{
  /deep/ button, /deep/ li{
    border: 1px solid #EEEEEE;
    border-radius:2px;
    padding : 0 10px;
  }
  /deep/ li{
    margin:0 10px;
  }
}
</style>